import './App.css';
import Nerve from './Nerve/nerve';

const App = () => {
  return (
    <div className='App'>
      <Nerve />
    </div>
  );
}

export default App;
